import { isLogin } from "./Utils/common_utils";
import ShortlistCoaching from "../Pages/Roles/Admin/Reports/Feedback/index";
import { SEARCH_VALUE } from "../Redux/actions";
export const userLoge = {
  admin: "/ManageInfo",
  partner: "/CoachHome",
  employee: "/OrganizationHome",
  finance_admin: "/FinanceAdminHome",
};

export const programInfo = [
  "coaching",
  "coaching session/s",
  "verbal 360 stakeholder interviews",
  "online 360",
];
//to-do : remove permissions acc to levels
export const accessPermissionConstant = {
  "level 1": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client"],
          marginPer: false,
        },
      },
      shortlistCoachesTab: {
        disableData: true,
      },
      employee: {
        disableViewIcon: true,
        disableAddButton: true,
      },
      actionPlaning: [],
      caf: {
        copyURL: false,
      },
      program: {
        disableEditIcon: true,
        disableAddButton: true,
      },
      coaches: {
        directCoachDetail: true,
      },
      others: {
        rateCard: {
          disableEditIcon: true,
          disableViewIcon: true,
        },
        terms_and_policy: {
          disablePage: true,
        },
      },
      forms: {
        disableForm: true,
      },
      editAssignment: false,
      showLeftNavBar: true,
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
  "level 2": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client"],
          marginPer: false,
        },
      },
      actionPlaning: [],
      caf: {
        copyURL: false,
      },
      editAssignment: false,
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
  "level 3": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client"],
          marginPer: false,
        },
      },
      actionPlaning: [],
      caf: {
        copyURL: false,
      },
      editAssignment: false,
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
  "level 4": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client"],
          marginPer: false,
        },
      },
      actionPlaning: [],
      caf: {
        copyURL: false,
      },
      editAssignment: false,
    },
    navigation: ["Home", "MI", "Reports", "Coaching Request", "Coach Search"],
  },
  "level 5": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client", "Supplier"],
          marginPer: false,
        },
      },
      actionPlaning: ["Edit", "Complete", "Cancel"],
      caf: {
        copyURL: false,
      },
      editAssignment: false,
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
  "level 6": {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
      ],
      moduleNotShow: ["Evaluation"],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client", "Supplier"],
          marginPer: false,
        },
      },
      actionPlaning: ["Edit", "Complete", "Cancel"],
      caf: {
        copyURL: false,
      },
      editAssignment: false,
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
  admin: {
    assignmentDetail: {
      sidebar: [
        "CRF",
        "CAF",
        "Feedback",
        "Internal Use only",
        "Coach shortlist",
        "Evaluation",
      ],
      ShortlistCoaching: {
        unChangeName: true,
      },
      moduleNotShow: [],
      assignmentOverview: {
        commercialBilling: {
          tabs: ["Client", "Supplier"],
          marginPer: true,
        },
        activityLog: {
          displayEditIcon: true,
          displayDeleteIcon: true,
          displayAddButton: true,
        },
      },
      actionPlaning: ["Edit", "Complete", "Cancel"],
      caf: {
        copyURL: true,
        displayEditIcon: true,
      },
      editAssignment: true,
      sessions: {
        showAcuityNotes: true,
      },
    },
    navigation: [
      "Home",
      "MI",
      "Dashboard",
      "Reports",
      "Coaching Request",
      "Coach Search",
    ],
  },
};

export const fetchLevelAccess = (jobRole, userData) => {
  if (isLogin()) {
    const accessLevel = userData?.job_role_access_level?.find(
      (item) => item.job_role === jobRole
    )?.access_level;
    const accessPermission =
      accessPermissionConstant[
        accessLevel ? accessLevel.toLowerCase() : "admin"
      ];
    return {
      accessLevel,
      accessPermission,
    };
  }
  return {};
};

export const CancellationReasons = [
  "Individual left organisation (before assignment began)",
  "Individual left organisation (before assignment completed)",
  "No longer required/approval declined (inc. Budget)",
  "Non-Acuity Partner selected",
  "No traction",
  "Cancelled by client/individual before completion",
  "Cancelled by Partner before completion",
  "Partner match not found",
  "Hesitant to start",
  "Other",
];

export const updateSearchValue = (value) => ({
  type: SEARCH_VALUE,
  payload: value,
});